import { createCollection, type Collection } from '@tanstack/react-db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';
import type { QueryClient } from '@tanstack/react-query';
import { fetchCategoriesTree } from './api';
import type { CategoryResponse } from './models';

/**
 * Creates a collection for categories with TanStack Query integration.
 *
 * Note: Type assertion is needed due to a mismatch between queryCollectionOptions
 * returning key type `string` and createCollection expecting `string | number`.
 * This is a known limitation in TanStack DB beta.
 * See: https://github.com/TanStack/db/issues/675
 */
export const createCategoryCollection = (
  tenantId: string,
  queryClient: QueryClient
): Collection<CategoryResponse> =>
  createCollection<CategoryResponse>(
    queryCollectionOptions({
      // Anagrafica per le RICERCHE (nome, colore, icona di un movimento già
      // categorizzato, previsionale): include le archiviate. I picker le
      // tolgono con `excludeArchivedCategories`.
      queryKey: [
        'category',
        tenantId,
        'list',
        { includeChildren: true, includeArchived: true },
      ],
      queryFn: async () => {
        const response = await fetchCategoriesTree(tenantId, {
          includeArchived: true,
        });
        return response.data as CategoryResponse[];
      },
      queryClient,
      getKey: (item) => item.id,
      staleTime: Infinity, // Master data - only invalidated by mutations
    }) as never
  );

export type CategoryCollection = Collection<CategoryResponse>;
